// 用户管理
import http from "@/jslibs/axios/http";

// 用户详情
export const detail = (data) => http.get(`v1/cms/cookie_user/${data.uuid}`);

// 用户列表
export const list = (data) => http.get("/v1/cms/cookie_user", data);
